import { css } from 'styled-components';
import token from 'styled-token';
import { spaceMixin } from '../spaceMixin';
import { spacingMixin } from '../spacingMixin';
import { typographyMixin } from '../typographyMixin';

/** @class CardHeaderMixin */
/** @method */
export var CardHeaderMixin = function CardHeaderMixin(props) {
  return token({
    fontType: 'CardHeader.fontType',
    borderColor: 'Card.separatorColor',
    marginTop: 'CardHeader.marginTop',
    marginBottom: 'CardHeader.marginBottom',
    borderBottomWidth: 'CardHeader.borderBottomWidth',
    paddingBottom: 'CardHeader.paddingBottom'
  }, function (_ref) {
    var fontType = _ref.fontType,
      borderColor = _ref.borderColor,
      _ref$marginTop = _ref.marginTop,
      marginTop = _ref$marginTop === void 0 ? 0 : _ref$marginTop,
      marginBottom = _ref.marginBottom,
      _ref$borderBottomWidt = _ref.borderBottomWidth,
      borderBottomWidth = _ref$borderBottomWidt === void 0 ? 1 : _ref$borderBottomWidt,
      paddingBottom = _ref.paddingBottom;
    return css(["", " padding-bottom:", ";border-bottom:", "px solid ", ";margin-top:", "px;margin-bottom:", ";", ""], typographyMixin(Object.assign({
      fontType: fontType
    }, props)), paddingBottom ? paddingBottom + "px" : spaceMixin('sm')(props), borderBottomWidth, borderColor, marginTop, marginBottom ? marginBottom + "px" : spaceMixin('md')(props), spacingMixin(props));
  })(props);
};